import Container from "@components/helper/container";
import { ILanguageHelper, normalLanguageHelper } from "@helper/static-language-helper";
import { NextPage } from "next";

export async function getStaticProps({ locale }: ILanguageHelper) {
    return normalLanguageHelper({ locale });
}

const Index: NextPage = () => {
    return (
        <Container>
            <div className="flex flex-col pt-24 text-rc-white sm:space-y-4">
                <span className="flex justify-center text-4xl">Imprint Realclixx</span>
                <div className="font-bold">Responsible in the sense of the Telemedia Act (TMG)</div>
                <p>RealClixx eK</p>
                <p>Marco Matanza</p>
                <p>Sägewerkstr. 5</p>
                <p>83416 Saaldorf-Surheim</p>
                <p>Germany</p>
                <br />
                <a href={`mailto:info@realclixx.com`}>info@realclixx.com</a>
                <br />
                <br />
                <span className="flex justify-center text-4xl">Trademark</span>
                <p>
                    In this content, registered trademarks, trade names and common names are used. Even if these are not marked as such, the
                    corresponding protection provisions apply.
                </p>
                <br />
                <br />
                <span className="flex justify-center text-4xl">consumer information according to EU Regulation No. 524/2013</span>
                <p>
                    Under the Regulation on Online Dispute Resolution in Consumer Matters, an online dispute resolution platform of the EU Commission
                    is available to you at http://ec.europa.eu/consumers/odr/.
                </p>
            </div>
        </Container>
    );
};

export default Index;
